<template>

<core-panel>

	<template v-slot:head>

		<h1>Favoured Groups</h1>

		<p>The groups played with most.</p>

	</template>

	<template v-slot:body>

		<app-users type="player" :item="item" v-for="(item, index) in groups" :max="4" count-text="play" :key="index" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'groups',
			groups: []
		}

	},

	methods: {

		response: function(json) {

			this.groups = json.groups.groups

		}

	}

}

</script>